module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/tunnel-high-cube-42135bf7f30875b8a9eba31ebe0fa0e9.png";